import { defineComponent, computed } from 'vue';
import __vue_component__ from '../buttons/ButtonComponent/ButtonComponent.vue.js';
import __vue_component__$1 from './CenteredPage.vue.js';
import __vue_component__$2 from '../specific/portal/components/Portal/components/SearchResults/components/PortalMapViewToggle.vue.js';

var script = defineComponent({
    name: 'FixedFooterButton',
    components: {
        ButtonComponent: __vue_component__,
        CenteredPage: __vue_component__$1,
        PortalMapViewToggle: __vue_component__$2,
    },
    props: {
        disabled: Boolean,
        iconAnimation: {
            type: String,
            default: undefined,
        },
        isLoading: Boolean,
        mobileOnly: Boolean,
        secondaryComponent: {
            type: [Function, Object, String],
            default: undefined,
        },
        secondaryComponentProps: {
            type: Object,
            default: () => ({}),
        },
        show: Boolean,
        to: {
            type: [Object, String],
            default: null,
        },
        tooltip: {
            type: String,
            default: null,
        },
        label: {
            type: String,
            required: true,
        },
        iconRight: {
            type: String,
            default: null,
        },
    },
    setup(props) {
        const classNames = computed(() => {
            const names = [];
            if (props.mobileOnly)
                names.push('FixedFooterButton--mobile-only');
            if (props.show)
                names.push('FixedFooterButton--show');
            return names;
        });
        return {
            classNames,
        };
    },
});

export { script as default };
